import { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'
import {t} from 'i18next'
import { useRecoilValue } from 'recoil';
import { Row, Col, Button, ModalBody, ModalHeader, ModalFooter } from 'reactstrap'
import axios from 'axios';

import env from '../../../env/src_config';
import { isNull } from '../../../izUtils';
import { linker, transformer } from '../../../helpers/fields';
import { axiosError, errorStatus } from '../../../helpers/response';
import { headersState } from '../../../recoil/recoil';
import Spinner from '../../spinner/Spinner';

const ExportModal = ({ setExportModal }) => {
    const navigate = useNavigate();

    const headers = useRecoilValue(headersState);
    const [inputs, setInputs] = useState(null);
    const [showErrors, setShowErrors] = useState(false);

    useEffect(() => {
        updateData(false, null);

    }, []) // eslint-disable-line

    const updateData = (save, passedInputs) => {
        let payload = { save };

        if (!isNull(passedInputs)) {
            payload.data = {};
            const keys = Object.keys(passedInputs);

            for (let i = 0; i < keys.length; i++) {
                if (!isNull(passedInputs[keys[i]].value) && passedInputs[keys[i]].value.length !== 0) {
                    payload.data[keys[i]] = passedInputs[keys[i]].value;
                } else {
                    payload.data[keys[i]] = "";
                }
            }
        }

        let sendHeaders = { headers: {...headers} };
        if (save) {
            sendHeaders.responseType = 'blob';
        }

        axios.post(env.api + '/api/standby/export', payload, sendHeaders).then(response => {
            if (save) {
                if (response.data.type.includes('spreadsheetml.sheet')) {
                    const href = window.URL.createObjectURL(response.data);
                    const a = document.createElement('a');
                    const contentDisposition = response.headers['content-disposition'];
                    let filename = 'export.xlsx';
                    if (contentDisposition) {
                        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                        if (filenameMatch && filenameMatch[1]) {
                            filename = filenameMatch[1].replace(/['"]/g, '');
                        }
                    }
                    a.setAttribute('download', filename);
                    a.href = href;
                    a.click();
                    window.URL.revokeObjectURL(href); // Clean up the object URL

                    setExportModal();
                } else {
                    errorStatus(response.data, t);
                    setShowErrors(true);
                }
            }

            if (!isNull(response.data.data)) {
                let transformedResponse = transformer(response.data.data);
                setInputs(transformedResponse);
            }
        }).catch(error => {
            axiosError(error, navigate);
        });
    }

    const textChange = (value, name) => {
        let clonedInputs = {...inputs}
        clonedInputs[name].value = value;
        updateData(false, clonedInputs);
    }

    const mapLinker = (field) => {
        const inputlinkerFields = {
            field,
            inputs,
            showErrors,
            component: {id: 'import'},
            textHandler: (value, id) => textChange(value, id),
            selectHandler: (value, id) => textChange(value, id),
            booleanHandler: (value, id) => textChange(value, id),
        }

        return linker(inputlinkerFields);
    }

    return (
        <Fragment>
            <ModalHeader toggle={setExportModal}>{t('standby.export.title')}</ModalHeader>
            <ModalBody>
                {isNull(inputs)
                    ? <Spinner />
                    : <div className="theme-form">
                        <Row>
                            <Col sm="12">
                                {['export_year', 'remap_year'].map(field => mapLinker(field))}
                            </Col>
                        </Row>
                    </div>
                }
            </ModalBody>
            <ModalFooter>
                <div className='w-100 d-flex justify-content-between'>
                    <Button color="secondary" onClick={setExportModal}>{t('close')}</Button>
                    <Button color="primary" onClick={() => updateData(true, inputs)}>{t('export')}</Button>
                </div>
            </ModalFooter>
        </Fragment>
    )
}

export default ExportModal